export default "__VITE_ASSET__D1N_kakQ__"